<template>
    <div class="gray-back" style="height: 100%" >
        <div class="box">
            <van-tabs v-model="active" class="tab-nav" sticky @click="onStatusChange">
                <van-tab title="进行中"></van-tab>
                <van-tab title="未开始"></van-tab>
                <van-tab title="已结束"></van-tab>
                <van-tab title="全部"></van-tab>

                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                  
                    <van-list
                            v-model="loading"
                            :finished="finished"
                            finished-text="没有更多了"
                            @load="onLoad"
                    > 
      <van-cell-group>

                  <van-cell :key="index" v-for="(row,index) in list" :title="row.title" @click="goDetail(row)"  is-link=""> 
                      <template slot="label">
                        <span class="font-size0 van-color-text-assist">{{row.saiqu_name}}</span>
                      </template>
                      <template>
                      <span style="color:#1989fa" v-if="row.status==1" >未开始</span> 
                      <span style="color:#32ae57"  v-else-if="row.status==2">进行中</span>  
                      <span style="color:#999"  v-else-if="row.status==3">已结束</span> 
                      <span style="color:#999"  v-else-if="row.status==4">已结束</span> 
                    </template>
                  </van-cell>
      </van-cell-group>
                    </van-list>
                </van-pull-refresh>
            </van-tabs>


        </div>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 50px;*/
        background: rgba(248,248,248,1);
        min-height: 90vh;
    }
    .van-pull-refresh{
        margin-top: 0.3rem
    }     

</style>

<script>
    import Vue from 'vue';

    import {Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button,DropdownMenu, DropdownItem,
            Tab,
            Tabs,
            NoticeBar,
    } from 'vant';

    Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(Tab).use(Tabs).use(DropdownItem);
    export default {
        name: 'GoodsList',
        components: {
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
        },
        data: function () {
            return {
                loginShow: false,
                active: 0,
                isLoading: false,
                loading: false,
                finished: false,
                params: {
                    pageNo: 1,
                    pageSize: 10,
                    status: 2
                },
                homeTop : 0,
                list: [],
                userType:2
            }
        },
        mounted() {
            document.title = "选择场次"

            let that = this;
            // console.log(this.$route.meta) 
            that.list = [];
            that.active =0;
            that.params.pageNo = 1;
            that.params.status = 2;
            that.loading = true;
            that.finished = false;
            that.getList()

            if (this.$route.query.status) {
                that.active = that.params.status = this.$route.query.status;
                console.log(that.active)
            }
            document.getElementById('app').scrollTop = this.homeTop || 0
            this.$route.meta.isBack = false;

        },
        destroyed() {
        },
        methods: {
            getList() {
                let that = this;
                that.$api.get('/api/dscore/scoreStartAllList', that.params, (res) => {
                    that.loading = false;

                    if (res.data.currentpage == 1) {
                        that.isLoading = false;
                        that.list = res.data.list
                    } else {
                        let list = that.list.concat(res.data.list);

                        that.list = list;
                    }

                    if (res.data.list.length == 0) {
                        that.finished = true;
                    }
                    that.params.pageNo += 1;
                })
            },


            // 上拉加载
            // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
            // 可以延迟异步的时间
            onLoad() {
                // console.log(1)
                // 异步更新数据
                console.log('this.params.pageNo')

                if (this.params.pageNo > 1) {
                    setTimeout(() => {
                        this.getList()
                    }, 500);
                }

            },
            onRefresh() {
                let that = this;
                that.params.pageNo = 1;
                that.getList();
            },


            // 更改状态
            onStatusChange(index) {

                let status = 0;
                if(index == 0){
                    status = 2
                }else if(index == 1){
                    status = 1
                }else if(index == 2){
                    status = [3,4]
                }
                let that = this;
                that.params.status = status;
                that.params.pageNo = 1;

                // 激活下拉
                that.finished = false;
                that.loading = true;
                that.list = [];

                this.$route.query.status = 0;
                that.getList()
            },



            // 跳转订单详情
            goDetail(  order) {
                // 判断是否成团
                console.log( order)
                rbLink({
                    'name' : 'StartList',
                    'query':{
                        start_id: order.id
                    }
                } )

            },

        }
    }
</script>



// WEBPACK FOOTER //
// StartListOption.vue?d8defcc2